import React, {Component} from "react";
import _ from "lodash";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import UNINITIALISED, {isInitialised} from "utils/uninitialised";
import Permissioner from "utils/permissioner";
import setTitle from "utils/set_title";
import PlaybooksComponent from "../components/playbooks";
import updateIssueset from "modules/organisation/actions/issueset_update";

import byId from "common/utils/by_id";
import issueOverrideTagsFetchAction from "modules/issue_override_tags/actions/fetch";
import updateIssueOverrideTagValuesAction from "modules/documents/actions/issue_update_tag_override_values";
import updateIssueAction from "modules/documents/actions/issue_update";
import addIssueAction from "modules/documents/actions/issue_add";

import requestor from "requestor";
import {LOADING} from "common/types/util";

const SESSION_TAG_KEY = "selected_issue_override_tag";

class SearchContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIssueOverrideTag: "",
    };
  }

  render() {
    if (!this.shouldRenderContainer()) {
      return <div />;
    }
    if (!this.hasPermission()) {
      return this.getNoPermissionMessage();
    }
    return this.renderComponent();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.issueOverrideTags !== this.props.issueOverrideTags &&
      Array.isArray(this.props.issueOverrideTags)
    ) {
      const savedTag = sessionStorage.getItem(SESSION_TAG_KEY);
      if (
        savedTag &&
        this.props.issueOverrideTags.some(tag => tag.id.toString() === savedTag)
      ) {
        this.handleTagChange(savedTag);
      } else {
        sessionStorage.removeItem(SESSION_TAG_KEY);
        this.handleTagChange("");
      }
    }
  }

  handleTagChange = value => {
    if (value) {
      sessionStorage.setItem(SESSION_TAG_KEY, value);
    } else {
      sessionStorage.removeItem(SESSION_TAG_KEY);
    }
    this.setState({selectedIssueOverrideTag: value});
  };

  renderComponent() {
    setTitle("Playbooks");
    return (
      <PlaybooksComponent
        organisationId={this.props.params.organisationId}
        contractTypes={this.props.contractTypes}
        projects={this.props.projects}
        issuesById={byId(this.props.issues)}
        updateIssueset={this.updateIssueset}
        updateIssue={this.updateIssue}
        fetchIssueOverrideTags={this.fetchIssueOverrideTags}
        issueOverrideTags={this.props.issueOverrideTags}
        selectedIssueOverrideTag={this.state.selectedIssueOverrideTag}
        onTagChange={this.handleTagChange}
        user={this.props.user}
        updateIssueOverrideTagValues={this.updateIssueOverrideTagValues}
        workflows={this.props.workflows}
        addIssue={this.addIssue}
      />
    );
  }

  shouldRenderContainer = () => {
    return this.havePropsBeenInitialisedForFilters(this.props);
  };

  havePropsBeenInitialisedForFilters = props => {
    return isInitialised(
      _.chain(["contractTypes", "issues", "workflows"])
        .map(item => props[item])
        .value(),
    );
  };

  hasPermission = () => {
    return Boolean(
      new Permissioner(this.props.user).hasPermission("view-playbook"),
    );
  };

  getNoPermissionMessage = () => {
    return new Permissioner(this.props.user).getNoPermissionMessage();
  };

  fetchIssueOverrideTags = () => {
    this.props.issueOverrideTagsFetch(this.props.params.organisationId);
  };

  updateIssueOverrideTagValues = (issueId, overrides) => {
    const {organisationId} = this.props.params;
    this.props.updateIssueOverrideTagValues(organisationId, issueId, overrides);
  };

  updateIssueset = (contractTypeId, issuesetId, values) => {
    this.props.updateIssueset(
      this.props.params.organisationId,
      contractTypeId,
      issuesetId,
      values,
    );
  };

  updateIssue = (issue, data) => {
    const {organisationId} = this.props.params;
    const issueIdInt = parseInt(issue.id, 10);

    const lastEdited = issue?.last_edited;

    return this.props.updateIssue(organisationId, issueIdInt, lastEdited, data);
  };

  addIssue = newIssue => {
    const {organisationId} = this.props.params;
    return this.props.addIssue(organisationId, newIssue);
  };
}

const mapStateToProps = state => ({
  user: state.user,
  contractTypes: state.contract_types,
  projects: state.projects,
  issues: state.issues,
  workflows: state.workflows,
  issueOverrideTags:
    state.issueOverrideTags !== UNINITIALISED
      ? state.issueOverrideTags
      : LOADING,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateIssue: updateIssueAction(requestor),
      updateIssueset,
      updateIssueOverrideTagValues: updateIssueOverrideTagValuesAction(
        requestor,
      ),
      issueOverrideTagsFetch: issueOverrideTagsFetchAction(requestor),
      addIssue: addIssueAction(requestor),
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(SearchContainer);
